"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetPresignedSignatureUrl = void 0;
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var GetPresignedSignatureUrl = exports.GetPresignedSignatureUrl = (0, _graphqlTag["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getPresignedSignatureUrl {\n    getPresignedSignatureUrl {\n      url\n      key\n    }\n  }\n"])));
//# sourceMappingURL=queries.js.map